<template name="terms">
  <div id="terms">
    <h4 style="text-align: center">
      CONSENT FORM
    </h4>
    <h5 style="text-align: center">
      BrainSwipes Neuroimaging Quality Control App
    </h5>
    <br>
    <p>
Welcome to the BrainSwipes Neuroimaging QC App! We're very excited to have you join us as we quality assess thousands of brain images in this fast, fun, and streamlined application. Please carefully read our Data Use Agreement before you begin your training session.
    </p>
    <br>
    <p style="text-align: left">
    1.  The data within this application comes from many different studies. Publicly available datasets require no approval. For restricted datasets approved users agree that they have a valid Data Use Agreement both at their site and for their person.
    </p>
    <p style="text-align: left">
    2.  By signing up for the BrainSwipes application, you agree that you have been given explicit permission to participate in the quality assessment process by your supervisor, home institution, or other principal entity, or will only participate in quality assessment of publicly available datasets.
    </p>
    <p style="text-align: left">
    3.  Data being used within this application is for the explicit purpose of brain imaging quality assessment as defined by the training criteria within the application.
    </p>
    <p style="text-align: left">
    4.  These data will not be duplicated, photographed/recorded, or otherwise documented or shared externally unless at the permission or request of the BrainSwipes team.
    </p>
    <p style="text-align: left">
    5.  Data within this application have been stripped of all identifiable information and will not be used in an attempt to establish individual identities from the study.
    </p>
  </div>
</template>
<style>
  #terms {
    color: black;
  }
</style>
<script>
/**
 * **TODO**: This should be a researcher's consent form. It should come from a
 * a URL to a markdown file described in the `config` from the parent component.
 */
  export default {
    name: 'terms',
    data() {
      return {

      };
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/Terms.vue